import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const loginService = async (user) => {
  return api.create(url.POST_LOGIN, user);
};

export const logoutService = () => {
  sessionStorage.removeItem("authUser");
  return true;
};

// export const getCurrentUser = () => {
//   return JSON.parse(sessionStorage.getItem("authUser"));
// };

export const changePasswordService = (id, data) => {
  return api.create(url.POST_CHANGE_PASSWORD(id), data, true);
};

export const getAdminProfileService = (id) => {
  return api.get(url.GET_ADMIN_PROFILE(), { id });
};

export const updateProfileService = (formData, payload) => {
  return api.put(
    url.UPDATE_ADMIN_PROFILE_SM,
    formData,
    payload,
    true,
    false,
    true
  );
};

export const resetTokenService = (payload) => {
  return api.create(url.RESET_TOKEN, payload);
};
